<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_158_437)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.94477 7.57349C8.47614 7.10486 7.71635 7.10486 7.24772 7.57349C6.77909 8.04212 6.77909 8.80192 7.24772 9.27054L10.9772 13L7.24771 16.7294C6.77908 17.1981 6.77908 17.9579 7.24771 18.4265C7.71634 18.8951 8.47614 18.8951 8.94477 18.4265L12.6742 14.697L16.4037 18.4265C16.8723 18.8951 17.6321 18.8951 18.1007 18.4265C18.5694 17.9579 18.5694 17.1981 18.1007 16.7294L14.3713 13L18.1007 9.27055C18.5694 8.80192 18.5694 8.04212 18.1007 7.57349C17.6321 7.10486 16.8723 7.10486 16.4037 7.57349L12.6742 11.3029L8.94477 7.57349Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_158_437">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
